import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/common/NoBonuses.svg?url_encode")